(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zoe-purchase-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zoe-whatsapp')) {
  customElements.define('zoe-whatsapp', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.refresh = () => {
        const scope = this.closest('product-info') || this.closest('.shopify-section');
        const picker = scope && scope.querySelector('variant-selects');
        const values = picker ? Array.from(picker.querySelectorAll('input[type="radio"]:checked, select')).map(el => el.value).filter(Boolean) : [];
        const option = values.join(' / ') || this.dataset.fallback;
        const text = this.dataset.greeting + '\n' + this.dataset.modelLabel + ': ' + this.dataset.title + '\n' + this.dataset.optionLabel + ': ' + option + '\n' + this.dataset.url;
        this.link.href = 'https://wa.me/50663970633?text=' + encodeURIComponent(text);
      };
      this.link.addEventListener('pointerdown', this.refresh);
      this.link.addEventListener('focus', this.refresh);
      this.link.addEventListener('click', this.refresh);
      this.refresh();
    }
    disconnectedCallback() {
      this.link.removeEventListener('pointerdown', this.refresh);
      this.link.removeEventListener('focus', this.refresh);
      this.link.removeEventListener('click', this.refresh);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
